import React from 'react';
import { CategoryTypeString } from '@diritto/common/content/constants';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { shortenCount } from '@diritto/common/utils/string';
import { DotDivider } from 'ui-components/common/DotDivider';
import { ProfileName } from 'app-components/contents/ProfileName';

interface SectionTextContentMetaInfoProps {
  content: ContentPublicRelayDto;
  profile: ProfileLitePublicRelayDto;
}

export const SectionTextContentMetaInfo = ({ content, profile }: SectionTextContentMetaInfoProps) => (
  <div className={'flex flex-row items-center gap-1 text-xxxs font-medium leading-none text-gray-600'}>
    <ProfileName profile={profile} />
    <>
      <DotDivider />
      <div>{CategoryTypeString[content.categoryType]}</div>
    </>
    <>
      <DotDivider />
      <div>{content.counts.episodeCount}화</div>
    </>
    <>
      <DotDivider />
      <div className="flex items-center gap-[1px]">
        <span>{shortenCount(content.counts.viewCount)}</span>
        <span>조회</span>
      </div>
    </>
  </div>
);
